import { objectWithoutProperties as _objectWithoutProperties, extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.esm.js';
import React__default, { forwardRef, useMemo } from 'react';
import { useComponentTheme } from '../../../theme/theme.context.esm.js';
import { useCardContext } from '../card-context/card-context.esm.js';

var _excluded = ["children", "className", "gap", "justify"];
var CardFooter = /*#__PURE__*/forwardRef(function CardFooter(props, ref) {
  var theme = useComponentTheme('Card');
  var children = props.children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? 'lg' : _props$gap,
    justify = props.justify,
    rest = _objectWithoutProperties(props, _excluded);
  var _useCardContext = useCardContext(),
    padding = _useCardContext.padding,
    radius = _useCardContext.radius,
    withDivider = _useCardContext.withDivider;
  // const id = usePropId(props.id)
  var classes = useMemo(function () {
    return theme.footer({
      className: className,
      gap: gap,
      justify: justify,
      padding: padding,
      radius: radius,
      withDivider: !!withDivider
    });
  }, [theme, justify, gap, padding, className, radius, withDivider]);
  return /*#__PURE__*/React__default.createElement("div", _extends({
    // id={id}
    ref: ref,
    className: "csg-tw-card-footer ".concat(classes)
  }, rest), children);
});
CardFooter.displayName = 'Card.Footer';
var CardFooter$1 = CardFooter;

export { CardFooter$1 as default };
//# sourceMappingURL=card-footer.esm.js.map
